import styles from './PreviewBar.module.css'

export default function PreviewBar() {
  return <div className={styles.PreviewBar}>Preview</div>
}
